import React from "react";

const InfoStep: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="text-sm text-secondary-n-200">
          Connect your Claude Pro/Max account to unlock unlimited Claude Code in
          Tempo.
        </div>
        <div className="text-sm text-secondary-n-300">
          The following rate limits apply:
        </div>
        <ul className="space-y-3 text-sm text-secondary-n-300 mt-3">
          <li className="flex items-start gap-2">
            <span className="text-primary-n-500 mt-0.5">•</span>
            <span>
              <strong className="font-semibold">Claude Pro ($20/month):</strong>{" "}
              Average users can send approximately 10-40 prompts with Claude
              Code every five hours.
            </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary-n-500 mt-0.5">•</span>
            <span>
              <strong className="font-semibold">
                Claude Max 5x ($100/month):
              </strong>{" "}
              Average users can send approximately 50-200 prompts with Claude
              Code every five hours.
            </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary-n-500 mt-0.5">•</span>
            <span>
              <strong className="font-semibold">
                Claude Max 20x ($200/month):
              </strong>{" "}
              Average users can send approximately 200-800 prompts with Claude
              Code every five hours.
            </span>
          </li>
        </ul>
        <div className="text-xs text-secondary-n-400 mt-4">
          Read more about{" "}
          <a
            href="https://support.claude.com/en/articles/8324991-about-claude-s-pro-plan-usage"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-n-500 hover:text-primary-n-400 underline"
          >
            rate limits using Claude Code
          </a>
        </div>
        <div className="text-sm text-orange-400 bg-orange-500/10 border border-orange-500/20 rounded-md p-2">
          <strong>Note:</strong>
          <ul className="space-y-3 text-sm text-secondary-n-300 mt-2 list-disc list-inside">
            <li className="flex items-start gap-2">
              <span className="text-orange-400 mt-0.5 text-xs">•</span>
              <span>
                You can only use your Pro/Max subscription with Claude Code, you
                cannot use it for Tempo Max
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-orange-400 mt-0.5 text-xs">•</span>
              <span>
                Claude Code is generally slower than Tempo Max but often more
                thorough and accurate.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InfoStep;
